<template>
  <div class="section-white content-padded">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="设置小程序配置等" name="wxappseting">
        <wxappseting></wxappseting>
      </el-tab-pane>
      <el-tab-pane label="下载指定小程序码" name="source">
        <grcode></grcode>
      </el-tab-pane>
      <el-tab-pane label="生成小程序短连接" name="shortlink">
        <gshortlink></gshortlink>
      </el-tab-pane>
      <el-tab-pane label="设置小程序业务域名" name="webviewseting">
        <webviewseting></webviewseting>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
    import wxappseting from './setting_domain.vue'
    import grcode from './get_qrcode.vue'
    import gshortlink from './get_shortlink.vue'
    import webviewseting from './setting_webview.vue'
    export default {
        components: {
            wxappseting,
            grcode,
            gshortlink,
            webviewseting,
        },
        data () {
            return {
                activeName: 'wxappseting'
            }
        },
        methods: {
            handleClick (tab, event) {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// setting.vue?774a621a